export default {
  badge: 'Badge',
  close: 'Isara',
  dataIterator: {
    noResultsText: 'Walang nakitang katugmang mga tala',
    loadingText: 'Naglo-load ng mga item...',
  },
  dataTable: {
    itemsPerPageText: 'Mga hilera bawat pahina:',
    ariaLabel: {
      sortDescending: 'Pinagsunod-sunod pababa.',
      sortAscending: 'Pinagsunod-sunod pataas.',
      sortNone: 'Hindi inayos.',
      activateNone: 'I-activate para alisin ang pag-uuri.',
      activateDescending: 'I-activate para pagbukud-bukurin pababa.',
      activateAscending: 'I-activate para pagbukud-bukurin ang pataas.',
    },
    sortBy: 'Pagbukud-bukurin ayon sa',
  },
  dataFooter: {
    itemsPerPageText: 'Mga item sa bawat pahina:',
    itemsPerPageAll: 'Lahat',
    nextPage: 'Susunod na pahina',
    prevPage: 'Nakaraang pahina',
    firstPage: 'Unang pahina',
    lastPage: 'Huling pahina',
    pageText: '{0}-{1} ng {2}',
  },
  datePicker: {
    itemsSelected: '{0} ang napili',
    nextMonthAriaLabel: 'Susunod na buwan',
    nextYearAriaLabel: 'Sa susunod na taon',
    prevMonthAriaLabel: 'Nakaraang buwan',
    prevYearAriaLabel: 'Nakaraang taon',
  },
  noDataText: 'Walang available na data',
  carousel: {
    prev: 'Nakaraang visual',
    next: 'Susunod na visual',
    ariaLabel: {
      delimiter: 'Carousel slide {0} ng {1}',
    },
  },
  calendar: {
    moreEvents: '{0} pa',
  },
  fileInput: {
    counter: '{0} mga file',
    counterSize: '{0} mga file ({1} sa kabuuan)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Pag-navigate sa Pagbilang ng pahina',
      next: 'Susunod na pahina',
      previous: 'Nakaraang pahina',
      page: 'Pumunta sa Pahina {0}',
      currentPage: 'Kasalukuyang Pahina, Pahina {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: 'Rating {0} ng {1}',
    },
  },
};
